import { t } from 'i18next';
import { observer } from 'mobx-react';
import numeral from 'numeral';

import { useMeasurement } from '@/hooks/useMeasurement';
import {
  getDeviceSliderPointsArray,
  getSliderPoints,
  useMinSetpointValue,
  useSetpointValue,
} from '@/comp/MapBuilder/nodes/compressor/CompressorNodeWidget.utils';
import { CompressorActivityStateEnum } from '@/constants/enums';
import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';

import Slider from '../Slider/Slider';
import { DeviceType } from '@/constants/deviceTypeEnum';
import { MetricType } from '@/constants/metric-type.enum';

const BlowerSliders = observer(({ entity }: { entity: Entity }) => {
  const { tvalue } = useMeasurement();
  const {
    connectivity,
    activity,
    inletValveOpening,
    bypassValveOpening,
    blowerSpeedRPM,
    targetBlowerSpeedRPM,
    minimumBlowerSpeedRPM,
    maximumBlowerSpeedRPM,
  } = entity;
  const sliderPoints = getSliderPoints(t);

  return (
    <>
      <div className="main-slider">
        <Slider
          showTierLock
          title={t('blowerSpeed')}
          value={tvalue(Number(blowerSpeedRPM?.toFixed(2)), 'RPM')}
          unit="%"
          min={useMinSetpointValue(entity, MetricType.MinimumBlowerSpeedRPM)}
          max={useSetpointValue(entity, MetricType.MaximumBlowerSpeedRPM)}
          points={getDeviceSliderPointsArray(
            targetBlowerSpeedRPM,
            minimumBlowerSpeedRPM,
            maximumBlowerSpeedRPM,
            t,
            tvalue,
            DeviceType.Blower,
            'RPM',
          )}
          connectivity={connectivity}
          highlightSlider={activity?.toLowerCase() === CompressorActivityStateEnum.Load}
          addSideGaps
          hasTarget
        />
      </div>
      <div className="centrifugal-sliders">
        <div className="centrifugal-slider-wrapper">
          <Slider
            title={t('inletValve')}
            points={sliderPoints}
            value={numeral(inletValveOpening).format(0)}
            min={0}
            max={100}
            unit={'%'}
            connectivity={entity.connectivity}
            highlightSlider={entity.activity?.toLowerCase() === CompressorActivityStateEnum.Load}
          />
        </div>
        <div className="centrifugal-slider-wrapper">
          <Slider
            title={t('bypassValve')}
            points={sliderPoints}
            value={numeral(bypassValveOpening).format(0)}
            min={0}
            max={100}
            unit={'%'}
            connectivity={entity.connectivity}
            highlightSlider={entity.activity?.toLowerCase() === CompressorActivityStateEnum.Load}
          />
        </div>
      </div>
    </>
  );
});

export default BlowerSliders;
